import React from 'react';
import { useIntl } from 'react-intl';
import imgDashOne from '@/images/banner-dashboard-1.png';
import imgDashTwo from '@/images/banner-dashboard-2.png';
import InfoStepModal from '../InfoStepModal/InfoStepModal';

const InfoDashboardModal = ({ isOpen, onClose, onConfirm }) => {
  const intl = useIntl();
  const steps = [
    {
      label: intl.formatMessage({ id: 'infoDashboardModal.imgAlt1' }),
      text: intl.formatMessage({ id: 'infoDashboardModal.text1' }),
      imgPath: imgDashOne,
    },
    {
      label: intl.formatMessage({ id: 'infoDashboardModal.imgAlt2' }),
      text: intl.formatMessage({ id: 'infoDashboardModal.text2' }),
      imgPath: imgDashTwo,
    },
  ];
  return (
    <InfoStepModal
      title={intl.formatMessage({ id: 'infoDashboardModal.dashboard' })}
      textNextImg={intl.formatMessage({ id: 'infoStepModal.availableOnPlans' })}
      steps={steps}
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};

export default InfoDashboardModal;
